import React from 'react'
import { makeStyles } from '@mui/styles'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

import lang from '@/lang'
import langSub from '@/utils/langSub'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  icon: {
    color: theme.palette.warning.main,
    fontSize: 20,
    display: 'block',
  },
  tooltip: {
    fontSize: theme.fontSizes.smaller,
    color: theme.black,
  },
}))

interface IMassImportRequiredWarningProps {
  count: number
}

const MassImportRequiredWarning = ({ count }: IMassImportRequiredWarningProps) => {
  const classes = useStyles()

  if (!count) {
    return null
  }

  const content = count === 1
    ? lang.massImport2.requiredWarning.one
    : langSub('massImport2.requiredWarning.multiple', [{ template: '{{count}}', string: `${count}` }])

  return (
    <RichTooltip styles={{ tooltip: classes.tooltip }} content={content}>
      <WarningAmberRoundedIcon className={classes.icon} data-qs-id='mass-import-required-warning' />
    </RichTooltip>
  )
}

export default MassImportRequiredWarning
